module.exports = __webpack_public_path__ + "img/alternate-youtube-icon.eb78bcf9.svg";